import React from 'react';
import { Row, Title, QuestionNumberBadge } from 'pages/new-questions/styles/common';
import contextQuestionsIcon from 'img/context-questions-icon.svg';

interface QuestionHeaderProps {
  questionNumber?: number;
  totalQuestions?: number;
  caseCode?: string;
}

export const QuestionHeader: React.FC<QuestionHeaderProps> = ({
  questionNumber,
  totalQuestions,
  caseCode,
}) => {
  return (
    <Row padding="0 24px">
      <Title>
        {questionNumber && totalQuestions && (
          <QuestionNumberBadge>
            <p>
              {questionNumber}/{totalQuestions}
            </p>
          </QuestionNumberBadge>
        )}
        <img
          src={contextQuestionsIcon}
          alt="Contexto do caso questões contextuais"
          width={24}
          height={24}
        />
        <p>Caso: {caseCode}</p>
      </Title>
    </Row>
  );
};
